export default "__VITE_ASSET__03ab8c42__"